var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n    .pin-path {\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 13;\n      stroke-miterlimit: 10;\n    }\n\n    .pin-circle {\n      fill: currentColor;\n    }\n  "),React.createElement("g",{"key":1},[React.createElement("path",{"className":"pin-path","d":"M264.8,134.5c0,56.5-102.3,161.2-102.3,161.2S60.2,191,60.2,134.5C60.2,78,106,32.2,162.5,32.2\n\t\tC219,32.2,264.8,78,264.8,134.5z","key":0}),React.createElement("circle",{"className":"pin-circle","cx":"162.5","cy":"126.8","r":"38.1","key":1})])]);
}

Pin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 325 327.9","style":{"enableBackground":"new 0 0 325 327.9"},"xmlSpace":"preserve"};

module.exports = Pin;

Pin.default = Pin;
